/**
 * Aç/kapa anahtarı. Listede satırdan çıkmadan durum değiştirmek için —
 * checkbox'a göre okunaklı ve dokunmatikte isabetli.
 */
export default function Toggle({
  checked,
  onChange,
  disabled,
  title,
  size = "md",
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  title?: string;
  size?: "sm" | "md";
}) {
  const w = size === "sm" ? "w-9 h-5" : "w-11 h-6";
  const knob = size === "sm" ? "h-4 w-4" : "h-5 w-5";
  const shift = size === "sm" ? "translate-x-4" : "translate-x-5";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      title={title}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!disabled) onChange(!checked);
      }}
      className={[
        w,
        "relative shrink-0 rounded-full transition border",
        disabled
          ? "opacity-40 cursor-not-allowed border-stroke bg-surfaceHigh"
          : checked
          ? "bg-success/80 border-success/60"
          : "bg-surfaceHigh border-stroke hover:border-strokeStrong",
      ].join(" ")}
    >
      <span
        className={[
          knob,
          "absolute top-1/2 -translate-y-1/2 left-0.5 rounded-full bg-white shadow transition-transform",
          checked ? shift : "translate-x-0",
        ].join(" ")}
      />
    </button>
  );
}
